import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const FragranceSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section fragrance-section main-hp hp-section">
      <div className="mod-wrap bg-right">
        <Link href={t('fragranceLink')} className="module fragrance clearfix">
          <div className="branding-hero">
            <div className="img-wrap-tall">
              <picture>
                <source
                  srcSet="/images/homepage/fraganceSection/kem-fragrance-mob.webp"
                  media="(max-width: 768px)"
                />
                <img
                  src="/images/homepage/fraganceSection/kem-fragrance-dsktp.webp"
                  alt="Fragrance"
                  width={917}
                  height={775}
                />
              </picture>
            </div>
          </div>
          <div className="outer-wrap">
            <div className="inner-wrap">
              <div className="title">
                <div className="inner-title">
                  <h2>{t('fragranceHeading')}</h2>
                  <p>{t('fragranceText')}</p>
                  <Button ariaLabel={t('fragranceCta')}>{t('fragranceCta')}</Button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default FragranceSection;
